// extracted by mini-css-extract-plugin
export default {"root":"gkV83qsbD2st7FJNfrbT","btn":"D22v4661JvjOr0uhxZZ0","btnDetach":"OEse8U9XTSn2FQ_Dl33C"};